import { NgCardstackModule } from '@al/ng-cardstack-components';
import {
    AlOrdinalNumberPipe,
    NgGenericComponentsModule,
} from '@al/ng-generic-components';
import {
    NgNavigationModule,
} from '@al/ng-navigation-components';
import {
    CommonModule,
    TitleCasePipe,
} from '@angular/common';
import { NgModule } from '@angular/core';
import {
    FormsModule,
    ReactiveFormsModule,
} from '@angular/forms';
import { MonacoEditorModule, MONACO_PATH } from '@materia-ui/ngx-monaco-editor';
import { CalendarModule } from 'primeng-lts/calendar';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { ConfirmDialogModule } from 'primeng-lts/confirmdialog';
import { DropdownModule } from 'primeng-lts/dropdown';
import { InputSwitchModule } from 'primeng-lts/inputswitch';
import { InputTextModule } from 'primeng-lts/inputtext';
import { PanelModule } from 'primeng-lts/panel';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { ProgressSpinnerModule } from 'primeng-lts/progressspinner';
import { SlideMenuModule } from 'primeng-lts/slidemenu';
import { ChipsModule } from 'primeng-lts/chips';
import { AutoCompleteModule } from 'primeng-lts/autocomplete';
import { TooltipModule } from 'primeng-lts/tooltip';
import { MultiSelectModule } from 'primeng-lts/multiselect';
import * as components from './components';
import { AlBlobService } from './services/al-blob-service';
import { InputNumberModule } from 'primeng-lts/inputnumber';
import { AlSetupLinkURLPipe } from './pipes';
import { TabViewModule } from 'primeng-lts/tabview';
import { MessagesModule } from 'primeng-lts/messages';

@NgModule({
    declarations: [
        ...components.NOTIFICATIONS_COMPONENTS,
    ],
    imports: [
        CommonModule,
        CalendarModule,
        CheckboxModule,
        ConfirmDialogModule,
        DropdownModule,
        FormsModule,
        InputSwitchModule,
        InputTextModule,
        NgCardstackModule,
        NgGenericComponentsModule,
        NgNavigationModule,
        PanelModule,
        RadioButtonModule,
        ProgressSpinnerModule,
        ReactiveFormsModule,
        SlideMenuModule,
        ChipsModule,
        AutoCompleteModule,
        TooltipModule,
        MultiSelectModule,
        MonacoEditorModule,
        InputNumberModule,
        TabViewModule,
        MessagesModule,
    ],
    exports: [
        ...components.NOTIFICATIONS_COMPONENTS,
    ],
    providers: [
        TitleCasePipe,
        AlOrdinalNumberPipe,
        AlSetupLinkURLPipe,
        AlBlobService,
        {
            provide: MONACO_PATH,
            useValue: 'https://cdnjs.cloudflare.com/ajax/libs/monaco-editor/0.21.2/min/vs'
        }
    ]
})
export class NgNotificationsModule {
}
